import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';

export class SetNumbers extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedNumbers: [],
      targetNumber: '',
      is0Available: false,
      is10Available: true,
      is25Available: true,
      is50Available: true,
      is75Available: true,
      is100Available: true,
      isNumsAvailable: true,
      isComplete: false,
    };
  }

  handleNumberClick = (clickedNumber) => {
    let selectedNums = this.state.selectedNumbers;
    let targetNum = this.state.targetNumber;

    if (selectedNums.length < 6) {

      selectedNums.push(clickedNumber);
      this.setState({ selectedNumbers: selectedNums });

      if (clickedNumber === 25) this.setState({ is25Available: false });
      if (clickedNumber === 50) this.setState({ is50Available: false });
      if (clickedNumber === 75) this.setState({ is75Available: false });
      if (clickedNumber === 100) this.setState({ is100Available: false });

      if (selectedNums.length === 6) {
        this.setState({
          is10Available: false,
          is25Available: false,
          is50Available: false,
          is75Available: false,
          is100Available: false,
          is0Available: true,
          targetNumber: 0,
        });
      }

    } else {

      targetNum = targetNum * 10 + clickedNumber;
      this.setState({ targetNumber: targetNum });

      if (100 <= targetNum && targetNum <= 999) {
        this.setState({
          is0Available: false,
          isNumsAvailable: false,
          isComplete: true,
        });
      }
    }
  }

  renderSelected(numberExpr) {
    return (
      <DisplayButton
        value={numberExpr} />
    );
  }

  renderNumber(numberExpr, isAvailable) {
    if (isAvailable) {
      return (
        <NormalButton
          value={numberExpr}
          onClick={() => this.handleNumberClick(numberExpr)} />
      );
    }
    return (
      <DisabledButton
        value={numberExpr} />
    );
  }

  renderAcceptButton() {
    if (this.state.isComplete) {
      return (
        <AcceptButton
          onClick={() => this.props.onAcceptClick(this.state.selectedNumbers, this.state.targetNumber)} />
      );
    }
  }

  render() {

    let result =
      <div id='SetNumbers'>
        <Modal show={true} onHide={this.handleClose}>
          <Modal.Header>
            <Modal.Title>Set Numbers and Target</Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid">
            <div className="container">
              <div className="row">
                <div className="col-3 controlContainer">{this.renderSelected(this.state.selectedNumbers[0])}</div>
                <div className="col-3 controlContainer">{this.renderSelected(this.state.selectedNumbers[1])}</div>
                <div className="col-3 controlContainer">{this.renderSelected(this.state.selectedNumbers[2])}</div>
                <div className="col-3 controlContainer">{this.renderSelected(this.state.selectedNumbers[3])}</div>
              </div>
              <div className="row">
                <div className="col-3 controlContainer">{this.renderSelected(this.state.selectedNumbers[4])}</div>
                <div className="col-3 controlContainer">{this.renderSelected(this.state.selectedNumbers[5])}</div>
                <div className="col-6 controlContainer">{this.renderSelected(this.state.targetNumber)}</div>
              </div>
              <div className="row">
                <hr />
              </div>
              <div className="row">
                <div className="col-3 controlContainer">{this.renderNumber(1, this.state.isNumsAvailable)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(2, this.state.isNumsAvailable)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(3, this.state.isNumsAvailable)}</div>
              </div>
              <div className="row">
                <div className="col-3 controlContainer">{this.renderNumber(4, this.state.isNumsAvailable)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(5, this.state.isNumsAvailable)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(6, this.state.isNumsAvailable)}</div>
              </div>
              <div className="row">
                <div className="col-3 controlContainer">{this.renderNumber(7, this.state.isNumsAvailable)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(8, this.state.isNumsAvailable)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(9, this.state.isNumsAvailable)}</div>
              </div>
              <div className="row">
                <div className="col-3 controlContainer">{this.renderNumber(10, this.state.is10Available)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(0, this.state.is0Available)}</div>
                </div>
              <div className="row">
                <div className="col-3 controlContainer">{this.renderNumber(25, this.state.is25Available)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(50, this.state.is50Available)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(75, this.state.is75Available)}</div>
                <div className="col-3 controlContainer">{this.renderNumber(100, this.state.is100Available)}</div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.props.onCloseClick()}>
              Close
            </Button>
            {this.renderAcceptButton()}
          </Modal.Footer>
        </Modal>
      </div>

    return result;
  }
}

function DisabledButton(props) {
  return (
    <button className="disabledButton" >
      {props.value}
    </button>
  );
}

function DisplayButton(props) {
  return (
    <button className="displayButton" >
      {props.value}
    </button>
  );
}

function NormalButton(props) {
  return (
    <button className="calculationButton" onClick={() => props.onClick()} >
      {props.value}
    </button>
  );
}

function AcceptButton(props) {
  return (
    <Button variant="primary" onClick={() => props.onClick()}>
      Accept
    </Button>
  );
}

